const ChangeNotification = () => ( 
    alert("Notice:\nBecause of the change you just made you will need to finish enrollment again. Click on the Summary link to the left and re-enter your signature.\nYour enrollment will be considered incomplete until you re-enter your signature.")
);

export default ChangeNotification;